import React, { useEffect, useState } from "react";
import "./index.less";
import SuppliersTable from "./supplierTable";
import { useSelector } from "react-redux";

const Suppliers = () => {
  const { user } = useSelector((state) => state.authReducer);
  const [canUpdate, setCanUpdate] = useState(false);

  useEffect(() => {
    // if (user?.permissions?.departments?.add_edit) {
      setCanUpdate(true);
    // }
  }, [user]);

  return (
    <div className="page-top-div">
      <span className="text-span">Suppliers</span>
      <SuppliersTable canUpdate={canUpdate} />
    </div>
  );
};

export default Suppliers;
